module.exports = __webpack_public_path__ + "3653f6cb3653a573fd8cc12fec31f17e.svg";